import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ElementData } from '@app/core/models/courses.model';

@Component({
  selector: 'app-link-card',
  templateUrl: './link-card.component.html',
  styles: [],
  standalone: false,
})
export class LinkCardComponent {
  @Input() public element: ElementData;
  @Input() public fullWidth = false;
  @Input() public fullSize = false;
  @Input() public paddingBottom = false;

  constructor(protected sanitizer: DomSanitizer) {}

  public getSafeEmbedUrl(link: string): SafeResourceUrl | false {
    if (!link) return false;

    try {
      const url = new URL(link);
      const host = url.hostname;
      const pathname = url.pathname;

      if (host.includes('youtube.com') && url.searchParams.has('v')) {
        const videoId = url.searchParams.get('v');
        const embedUrl = `https://www.youtube.com/embed/${videoId}`;
        return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
      }

      if (host.includes('youtu.be')) {
        const videoId = pathname.slice(1);
        return this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${videoId}`);
      }

      if (host.includes('player.vimeo.com') && pathname.includes('/video/')) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(link);
      }
      if (host.includes('vimeo.com')) {
        const match = link.match(/vimeo\.com\/(\d+)/);
        if (match && match[1]) {
          return this.sanitizer.bypassSecurityTrustResourceUrl(`https://player.vimeo.com/video/${match[1]}`);
        }
      }
      return false;
    } catch (e) {
      return false;
    }
  }
}
